import {
  UI_COLOR_BORDER_TABLE,
  UI_COLOR_DANGER_BORDER,
  UI_COLOR_DANGER_SOFT,
  UI_COLOR_DANGER_SOFT_HOVER,
  UI_COLOR_DANGER_TEXT,
  UI_COLOR_SUCCESS_BORDER,
  UI_COLOR_SUCCESS_SOFT,
  UI_COLOR_SUCCESS_TEXT,
  UI_COLOR_SURFACE_TABLE_ACTIVE,
  UI_COLOR_SURFACE_TABLE_CHILD,
  UI_COLOR_SURFACE_TABLE_SUBTOTAL,
  UI_COLOR_SURFACE_TABLE_TOTAL,
  UI_COLOR_TEXT_NEUTRAL,
  UI_COLOR_WHITE
} from '../../../constants/uiColors'

export const BUYER_COLUMN_SX = {
  minWidth: 210,
  width: 220
}

export const METRIC_TABLE_PAPER_SX = {
  borderRadius: 3,
  border: `1px solid ${UI_COLOR_BORDER_TABLE}`
}

export const METRIC_TABLE_EMPTY_CELL_SX = {
  py: 2
}

export const METRIC_TABLE_INFO_ICON_WRAPPER_STYLE = {
  cursor: 'help',
  display: 'inline-flex',
  marginLeft: 6,
  marginTop: -3,
  verticalAlign: 'middle'
}

export const METRIC_TABLE_INFO_ICON_COLOR = UI_COLOR_WHITE

export const METRIC_TABLE_DIFFERENCE_BADGE_SX = {
  alignItems: 'center',
  borderRadius: '4px',
  display: 'inline-flex',
  fontSize: 12,
  fontWeight: 700,
  gap: 0.5,
  justifyContent: 'center',
  lineHeight: 1,
  minHeight: 20,
  minWidth: 84,
  px: 0.7
}

const METRIC_TABLE_POSITIVE_DIFFERENCE_BADGE_SX = {
  ...METRIC_TABLE_DIFFERENCE_BADGE_SX,
  backgroundColor: UI_COLOR_SUCCESS_SOFT,
  border: `1px solid ${UI_COLOR_SUCCESS_BORDER}`,
  color: UI_COLOR_SUCCESS_TEXT
}

const METRIC_TABLE_NEGATIVE_DIFFERENCE_BADGE_SX = {
  ...METRIC_TABLE_DIFFERENCE_BADGE_SX,
  backgroundColor: UI_COLOR_DANGER_SOFT,
  border: `1px solid ${UI_COLOR_DANGER_BORDER}`,
  color: UI_COLOR_DANGER_TEXT
}

export const getMetricTableDifferenceBadgeSx = (amount) =>
  Number(amount) > 0
    ? METRIC_TABLE_POSITIVE_DIFFERENCE_BADGE_SX
    : METRIC_TABLE_NEGATIVE_DIFFERENCE_BADGE_SX

export const getMetricTableClickableDifferenceBadgeSx = (amount) => ({
  ...getMetricTableDifferenceBadgeSx(amount),
  appearance: 'none',
  cursor: 'pointer',
  fontFamily: 'inherit',
  pl: 0.2,
  pr: 1.5,
  '&:hover': {
    backgroundColor: Number(amount) > 0
      ? UI_COLOR_SUCCESS_SOFT
      : UI_COLOR_DANGER_SOFT_HOVER
  }
})

export const METRIC_TABLE_DIFFERENCE_BADGE_ICON_SX = {
  fontSize: 14
}

export const METRIC_TABLE_BUYER_CELL_SX = {
  alignItems: 'center',
  display: 'flex',
  gap: 1,
  minWidth: 0
}

export const getMetricTableBuyerCellButtonSx = (hasChildren) => ({
  cursor: hasChildren ? 'pointer' : 'default',
  flex: '0 0 auto',
  opacity: hasChildren ? 1 : 0
})

export const METRIC_TABLE_BUYER_CELL_TEXT_SX = {
  minWidth: 0,
  overflowWrap: 'normal',
  whiteSpace: 'nowrap',
  wordBreak: 'keep-all'
}

export const getMetricTableHeadCellSx = (col) => ({
  py: 1.75,
  fontSize: 13,
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  ...(col.key === 'buyer' ? BUYER_COLUMN_SX : {})
})

export const getMetricTableParentRowSx = ({
  hasChildren,
  isOpen
}) => ({
  cursor: hasChildren ? 'pointer' : 'default',
  backgroundColor: isOpen ? UI_COLOR_SURFACE_TABLE_ACTIVE : 'inherit'
})

export const getMetricTableParentCellSx = ({ col, index }) => ({
  py: 1.25,
  fontWeight: index === 0 ? 700 : 400,
  ...(col.key === 'buyer' ? BUYER_COLUMN_SX : {})
})

export const getMetricTableChildRowSx = (hasDifference) => ({
  backgroundColor: UI_COLOR_SURFACE_TABLE_CHILD,
  ...differenceMarkerSx(hasDifference)
})

export const getMetricTableChildCellSx = ({ col, index }) => ({
  py: 1,
  pl: index === 0 ? 6 : 2,
  color: UI_COLOR_TEXT_NEUTRAL,
  ...(col.key === 'buyer' ? BUYER_COLUMN_SX : {})
})

export const METRIC_TABLE_SUBTOTAL_ROW_SX = {
  backgroundColor: UI_COLOR_SURFACE_TABLE_SUBTOTAL
}

export const getMetricTableSubtotalCellSx = (col) => ({
  fontWeight: 600,
  ...(col.key === 'buyer' ? BUYER_COLUMN_SX : {})
})

export const METRIC_TABLE_TOTAL_ROW_SX = {
  backgroundColor: UI_COLOR_SURFACE_TABLE_TOTAL
}

export const getMetricTableTotalCellSx = (col) => ({
  fontWeight: 700,
  ...(col.key === 'buyer' ? BUYER_COLUMN_SX : {})
})

export const differenceMarkerSx = (visible) => ({
  '& > td:first-of-type': {
    position: 'relative',
    ...(visible
      ? {
          '&::before': {
            backgroundColor: visible > 0 ? UI_COLOR_SUCCESS_TEXT : UI_COLOR_DANGER_TEXT,
            bottom: 0,
            content: '""',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 3
          }
        }
      : {})
  }
})
